/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
import * as import0 from '@angular/forms/src/directives/ng_form';
export var Wrapper_NgForm = (function () {
    function Wrapper_NgForm(p0, p1) {
        this._changed = false;
        this.context = new import0.NgForm(p0, p1);
    }
    Wrapper_NgForm.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_NgForm.prototype.ngOnDestroy = function () {
        (this.subscription0 && this.subscription0.unsubscribe());
    };
    Wrapper_NgForm.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_NgForm.prototype.checkHost = function (view, componentView, el, throwOnChange) {
    };
    Wrapper_NgForm.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        if ((eventName == 'submit')) {
            var pd_sub_0 = (this.context.onSubmit($event) !== false);
            result = (pd_sub_0 && result);
        }
        if ((eventName == 'reset')) {
            var pd_sub_1 = (this.context.onReset() !== false);
            result = (pd_sub_1 && result);
        }
        return result;
    };
    Wrapper_NgForm.prototype.subscribe = function (view, _eventHandler, emit0) {
        this._eventHandler = _eventHandler;
        if (emit0) {
            (this.subscription0 = this.context.ngSubmit.subscribe(_eventHandler.bind(view, 'ngSubmit')));
        }
    };
    return Wrapper_NgForm;
}());
//# sourceMappingURL=ng_form.ngfactory.js.map